<template>
    <v-group
            @mouseenter="hover(true)"
            @mouseleave="hover(false)"
    >
        <slot :hover="hovered"></slot>
    </v-group>
</template>

<script>
    export default {
        name: "BoxListingHover",

        emits: [
            'hover',
        ],

        data() {
            return {
                hovered: false,
            }
        },
        
        methods: {
            hover(state) {
                this.hovered = state;

                this.$emit('hover', state);
            },
            
        },
        
    }
</script>

<style>

</style>